import {Component} from "@angular/core";
import {EmptySearchParamsFilterModel} from "../../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchResultsFilterModel} from "../../../../shared/models/search/results/filters/search-results-filter.model";
import {UmbracoPageResultItem} from "../../../models/search-results/items/umbraco-page-result-item";
import {SearchTabDirective} from "../search-tab.directive";
import {ScopedSearchResultModel} from "../../../models/search-results/scoped-search-result.model";

@Component({
    selector: "pcg-ng-umbraco-pages-tab",
    template: require('./umbraco-pages-tab.component.html')
})
export class UmbracoPagesTabComponent extends SearchTabDirective<EmptySearchParamsFilterModel, ScopedSearchResultModel<UmbracoPageResultItem, SearchResultsFilterModel>> {

}
